module.exports = __webpack_public_path__ + "static/media/motion-design.7b85b4d1.svg";